module.exports = __webpack_public_path__ + "img/paytable_icon.10c36082.svg";